import { render, staticRenderFns } from "./AllItems.vue?vue&type=template&id=c1abea18&scoped=true&"
import script from "./AllItems.vue?vue&type=script&lang=js&"
export * from "./AllItems.vue?vue&type=script&lang=js&"
import style0 from "./AllItems.vue?vue&type=style&index=0&id=c1abea18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1abea18",
  null
  
)

export default component.exports